import { render, staticRenderFns } from "./icon-picker.vue?vue&type=template&id=184c2fb1&scoped=true"
import script from "./icon-picker.vue?vue&type=script&lang=ts"
export * from "./icon-picker.vue?vue&type=script&lang=ts"
import style0 from "./icon-picker.vue?vue&type=style&index=0&id=184c2fb1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184c2fb1",
  null
  
)

export default component.exports